import React, { useEffect, useRef } from "react";
import videojs from "video.js"; // Import video.js
import "video.js/dist/video-js.css"; // Import default Video.js styles

const VideoPlayer = ({ currentVideo }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (currentVideo && videoRef.current) {
      // Initialize Video.js
      const player = videojs(videoRef.current, {
        controls: true,
        autoplay: true,
        preload: "auto",
        responsive: false,
        fluid: false,
        width: 640, // Set the player width
        height: 360, // Set the player height
        controlBar: {
          children: [
            "playToggle", // Play/Pause button
            "volumePanel", // Volume control
            "progressControl", // Seek bar
            "fullscreenToggle", // Fullscreen button
            "remainingTimeDisplay", // Remaining time
            "currentTimeDisplay", // Current time
          ],
        },
        userActions: {
          hotkeys: true, // Enable hotkeys
        },
        sources: [
          {
            src: currentVideo.videoUrl, // Dynamic video URL
            type: "video/mp4",
          },
        ],
      });

      return () => {
        if (player) {
          player.dispose(); // Clean up Video.js instance
        }
      };
    }
  }, [currentVideo]);

  return (
    <div className="w-full flex justify-center mt-6">
      {currentVideo ? (
        <div data-vjs-player className="shadow-lg rounded-lg border">
          <video ref={videoRef} className="video-js vjs-default-skin"></video>
        </div>
      ) : (
        <p className="text-gray-500">No video selected</p>
      )}
    </div>
  );
};

export default VideoPlayer;
